import { render } from "./ModalTransferAbort.vue?vue&type=template&id=1d283a38"
import script from "./ModalTransferAbort.vue?vue&type=script&lang=js"
export * from "./ModalTransferAbort.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__